import {Signal} from "signals";
import {InitRecordSchema} from "../schema/init-record-schema";
import {SpinResponseSchema} from "../schema/spin-record-schema";
import {IIntegrationWrapper} from "./wrapper-mediator";

export class DefaultWrapper implements IIntegrationWrapper {
    public events = new Signal();

    public balanceUpdated = (balance: number) => {
    }

    public gameDataLoaded = (response: InitRecordSchema) => {
    }

    public gameLoaded = () => {
    }

    public init = () => {
    }

    public quit = () => {
    }

    public roundStart = (totalBet: number, balance: number) => {
    }

    public roundStarted = (spinId: number, balanceBeforeSpin?: number) => {
    }

    public spinResponseReceived = (response: SpinResponseSchema) => {
    }

    public reportPaused = () => {}

    public roundEnd = (win: number, bet: number, balance: number) => {}
    
    public autoplayStart = () => {};
    public autoplayEnd = () => {};

    public dispose = () => {
        this.events.removeAll();
        this.events = null;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/wrapper/DefaultWrapper.ts